import type { ReactNode } from 'react'
import type { FocusEvent } from 'react'
import { InputGroup } from '@systemeio/components'
import type { ParseKeys } from 'i18next'
import { useTranslation } from 'next-i18next/pages'
import { Controller, useFormContext } from 'react-hook-form'

interface AddPostInputFieldProps {
  name: string
  label: string
  maxLength?: number
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void
}

export default function AddPostInputField(props: AddPostInputFieldProps): ReactNode {
  const { control, watch, formState } = useFormContext()
  const { t } = useTranslation()
  const error = formState.errors[props.name]?.message as ParseKeys

  return (
    <div className="mb-6">
      <Controller
        control={control}
        name={props.name}
        render={({ field }) => (
          <div className="font-medium">
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-text-primary">{props.label}</label>
              <InputGroup.Root data-invalid={!!error || undefined}>
                <InputGroup.Input
                  data-testid="post-input"
                  value={field.value}
                  onChange={e => field.onChange(e.target.value)}
                  maxLength={props.maxLength}
                  onFocus={props.onFocus}
                />
                {props.maxLength !== undefined && (
                  <InputGroup.Addon align="inline-end">
                    <InputGroup.Text data-testid="post-input-counter">
                      {watch(props.name).length} / {props.maxLength}
                    </InputGroup.Text>
                  </InputGroup.Addon>
                )}
              </InputGroup.Root>
            </div>
          </div>
        )}
      />
      {error && <p className="mt-2 text-sm text-text-error">{t(error)}</p>}
    </div>
  )
}
